import { Controller } from "@hotwired/stimulus"

// "Show 4 more" over a list the card renders in full but only shows the first
// few of — the employment history today. The server decides what is hidden, so
// the short list is what arrives; this only reveals the rest.
//
// The activity stream has its own version of this inside history-groups, where
// the count has to be recomputed every time a filter changes. Nothing here
// filters, so it stays a button and a hidden attribute.
export default class extends Controller {
    static targets = ["row", "button"]

    showAll() {
        this.rowTargets.forEach((row) => { row.hidden = false })
        if (this.hasButtonTarget) this.buttonTarget.hidden = true
    }

    // The contact card's "+4 earlier roles" / "See more": the same reveal, but
    // the button stays as "Show less" and folds the rows back (Pieter,
    // 2026-10-14 - every "more" on the card needs its "less").
    toggle() {
        this.open = !this.open
        this.rowTargets.forEach((row) => { row.hidden = !this.open })
        if (!this.hasButtonTarget) return

        this.moreLabel ||= this.buttonTarget.textContent.trim()
        this.buttonTarget.textContent = this.open ? "Show less" : this.moreLabel
        this.buttonTarget.setAttribute("aria-expanded", this.open ? "true" : "false")
    }
}
